import { React, Fragment, PropTypes, reduxConnect } from '../lib/imports';

import { Spacing, Teaser } from '../components';
import { useCdnUrl, useCdnImage, getAssetSet } from '../app/context/config';
import { setSelectedAnswer, sendQuizAnswer } from './actions';
import TimsSkillTest from '../stq';

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const QuizApp = ({
  hasError,
  errorText,
  gameLocked,
  lockedText,
  title,
  text,
  termsText,
  question,
  answerTitle,
  answerOptions,
  selectedAnswer,
  btnText,
  btnVarient,
  btnDisabled,
  handleQuizAnswerClick,
  handleQuizSubmission,
}) => {
  const cdnUrl = useCdnUrl();

  return (
    <>
      {!hasError ? (
        <Spacing top bottom>
          <TimsSkillTest
            gameLocked={gameLocked}
            lockedText={lockedText}
            assetUrl={cdnUrl}
            title={title}
            text={text}
            question={question}
            answerTitle={answerTitle}
            items={answerOptions}
            onSelect={handleQuizAnswerClick}
            selected={selectedAnswer}
            btnText={btnText}
            btnVarient={btnVarient}
            btnDisabled={btnDisabled}
            onSubmit={handleQuizSubmission}
            termsText={termsText}
          />
        </Spacing>
      ) : (
        <Spacing sides top bottom>
          <Teaser src={assetSet(['sticks'])} text={errorText} />
        </Spacing>
      )}
    </>
  );
};

QuizApp.propTypes = {
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  showNotificationBar: PropTypes.bool,
  notificationBarTitle: PropTypes.string,
  notificationBarText: PropTypes.string,
  gameLocked: PropTypes.bool,
  lockedText: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  question: PropTypes.array,
  answerTitle: PropTypes.string,
  answerOptions: PropTypes.array,
  selectedAnswer: PropTypes.number,
  termsText: PropTypes.string,
  btnText: PropTypes.string,
  btnVarient: PropTypes.string,
  btnDisabled: PropTypes.bool,
  handleQuizAnswerClick: PropTypes.func,
  handleQuizSubmission: PropTypes.func,
  handleNotificationBarCloseClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { config, strings, onboarding, ui } = state;
  const { notificationBarOpen } = ui;
  const { questions, attempts, selectedAnswer, correctAnswer, options, lockout } = onboarding;

  const hasError = false;

  const showNotificationBar = attempts > 0 && !correctAnswer && notificationBarOpen;

  const notificationBarTitle = strings['notifications/quiz/wrongAnswer/title'];
  const notificationBarText = strings['notifications/quiz/wrongAnswer/text'];

  const operationText = {
    multiplyText: strings['quiz/question/multiply/text'],
    divideByText: strings['quiz/question/divideBy/text'],
    addText: strings['quiz/question/add/text'],
    subtractText: strings['quiz/question/subtract/text'],
  };

  const question = [
    {
      id: `question-${attempts}-multiply`,
      operator: operationText.multiplyText,
      operation: questions[attempts][0],
    },
    {
      id: `question-${attempts}-divide`,
      operator: operationText.divideByText,
      operation: questions[attempts][1],
    },
    {
      id: `question-${attempts}-add`,
      operator: operationText.addText,
      operation: questions[attempts][2],
    },
    {
      id: `question-${attempts}-subtract`,
      operator: operationText.subtractText,
      operation: questions[attempts][3],
    },
  ];

  const answerOptions = options[attempts].map((option) => {
    return {
      id: option,
      title: option,
    };
  });

  const defaultProps = {
    config,
    gameLocked: false,
    title: strings['quiz/helpInfo/text'],
    answerTitle: strings['quiz/answerTitle/text'],
    termsText: strings['modals/tierSelection/terms/text'],
    question,
    answerOptions,
    selectedAnswer,
    btnText: strings['button/submitAnswer/text'],
    btnVarient: 'primary',
    btnDisabled: !selectedAnswer,
  };

  if (lockout) {
    return {
      ...defaultProps,
      gameLocked: true,
      title: strings['notifications/quiz/gameLocked/checkBack/text'],
      text: strings['notifications/quiz/gameLocked/text'],
      lockedText: strings['notifications/quiz/gameLocked/checkBack/text'],
    };
  }

  return {
    ...defaultProps,
    showNotificationBar,
    notificationBarTitle,
    notificationBarText,
    hasError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleQuizAnswerClick: (id) => dispatch(setSelectedAnswer(id)),
    handleQuizSubmission: (answer) => dispatch(sendQuizAnswer(answer)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(QuizApp);
